import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '../../main/components/Header';
import CardQuickSelection from './CardQuickSelection';

const CardsLayout: React.FC = () => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <div className={classNames(['grid-container', 'padding-bottom-4', 'ofertas-campanhas'])}>
                <div className={classNames(['grid-x', 'grid-margin-x'])}>
                    <Header title={t(`home:landing.icons.cartaoValueCare`)} />
                    <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns', 'margin-top-2'])}>
                        <CardQuickSelection />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CardsLayout;
